import { useCadastrarEditarProdutoContext } from "../../../../contexts/CadastrarEditarProdutoContext";
import { ConfiguracaoPesoContainer } from "../../../../containers/ConfiguracaoPesoContainer";
import { ControleEstoqueContainer } from "../../../../containers/ControleEstoqueContainer";
import { ConfiguracaoImpostoContainer } from "../../../../containers/ConfiguracaoImpostoContainer";

export const CadastrarPesoContainer = () => {
    const { step } = useCadastrarEditarProdutoContext();

    return (
        <>
            {step == 0 && <ConfiguracaoPesoContainer />}
            {step == 1 && <ControleEstoqueContainer />}
            {step == 2 && <ConfiguracaoImpostoContainer />}
        </>
    );
};
